import { CommonModule } from "@angular/common";
import { Component, OnInit, ChangeDetectionStrategy, Signal } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { FuturesModeService } from "@services";
import { Observable } from "rxjs";
import { HeaderComponent } from "../../components/header/header.component";
import { LoadingTrackerService } from "src/app/core/service/loading-track.service";
import { LoaderComponent } from "src/app/shared/components/loader/loader.component";
import { FuturesFooterComponent } from "src/app/futures/footer/futures-footer.component";
import { FooterComponent } from "src/app/shared/components/footer/footer.component";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
    FuturesFooterComponent,
    CommonModule,
    LoaderComponent,
  ],
})
export class MainComponent implements OnInit {
  public infoBannerCookieKey: string = "isInfoBannerDismissed";
  public isInfoBannerDismissed: boolean = false;

  public readonly isFuturesRoute: Signal<boolean> = this._futuresModeService.isFuturesRoute;

  public isCookiesAccepted: boolean;
  public globalLoaderState: Observable<boolean> = this._loadingTrackerService.globalLoaderState$;

  constructor(
    private _cookieService: CookieService,
    private _router: Router,
    private _loadingTrackerService: LoadingTrackerService,
    private _futuresModeService: FuturesModeService,
  ) {}

  public ngOnInit(): void {
    this.isCookiesAccepted = this._cookieService.get("isCookieAccepted") === "true";
    this.isInfoBannerDismissed = !!this._cookieService.get(this.infoBannerCookieKey);
  }

  public handleCloseInfoBanner(): void {
    this._cookieService.set(this.infoBannerCookieKey, "true", 365);

    this.isInfoBannerDismissed = true;
  }

  public acceptCookie(): void {
    this._cookieService.set("isCookieAccepted", "true", 30);
    this.isCookiesAccepted = true;
  }

  public navigateToUrl(url: string): void {
    this._router.navigate([url]);
  }
}
